import { render, staticRenderFns } from "./CreativeCulture.vue?vue&type=template&id=6823c948&"
import script from "./CreativeCulture.vue?vue&type=script&lang=ts&"
export * from "./CreativeCulture.vue?vue&type=script&lang=ts&"
import style0 from "./CreativeCulture.vue?vue&type=style&index=0&id=6823c948&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports